import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 37 37"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M17.86 23.581a4.464 4.464 0 0 0 6.304 0l1.576-1.575a4.464 4.464 0 0 1 6.304 0l3.151 3.151a4.11 4.11 0 0 1 0 6.303c-8.253 8.254-17.753 4.333-26.03-3.944C.885 19.239-3.016 9.75 5.24 1.496a4.113 4.113 0 0 1 6.304 0l3.152 3.15a4.46 4.46 0 0 1 0 6.303l-1.576 1.576a4.46 4.46 0 0 0 0 6.303z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }